import { Box } from "@mui/material";

import { Link, useNavigate } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import SearchTable from "pages/components/Molecules/SearchTable";
import { DEBTOR_SEARCH } from "Application/RequestTypes";
import { UserProfile } from "Domain/User/Entity/UserProfile";
import Button from "pages/components/FormFields/Button";
import AddIcon from "@mui/icons-material/Add";
import {
  getUrl,
  CREATE_DEBTOR,
  DEBTOR_DETAIL,
  PAYMENT_PLAN_CREATE,
} from "Infrastructure/config/routesConfig";
import { formatDateTime } from "pages/Utils/Formats";
import { useTranslation } from "react-i18next";
import { FilterConfig } from "pages/components/Molecules/SearchFilter";

export default function DebtorsList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  function addNewCreditor() {
    navigate(getUrl(CREATE_DEBTOR));
  }
  function handleCreatePaymentPlan(debtorPublicId: string) {
    navigate(`${getUrl(PAYMENT_PLAN_CREATE)}?debtor=${debtorPublicId}`);
  }

  const columns: GridColDef<UserProfile>[] = [
    {
      field: "name",
      flex: 1,
      renderCell: (params) => (
        <Link to={getUrl(DEBTOR_DETAIL, { id: params.row.publicId })}>
          {params.row?.firstName + " " + params.row?.lastName}
        </Link>
      ),
    },
    {
      field: "externalIdentifier",
      flex: 1,
    },
    {
      field: "city",
      flex: 1,
    },
    {
      field: "mobile",
      flex: 1,
    },
    {
      field: "createdAt",
      flex: 1,
      type: "string",
      valueGetter: (value, row) => formatDateTime(row.createdAt),
    },
    {
      field: "email",
      flex: 1,
      type: "string",
    },
    {
      field: "action",
      flex: 1,
      renderCell: (params) => (
        <Button
          label={t(`FORM.SUBMIT.create_payment_plan`)}
          size="small"
          onClick={() => {
            handleCreatePaymentPlan(params.row.publicId);
          }}
        />
      ),
    },
  ];

  return (
    <>
      <Box display={"flex"} justifyContent={"end"} paddingBottom={1}>
        <Button
          color="success"
          onClick={addNewCreditor}
          startIcon={<AddIcon />}
          label={"Nouveau Patient"}
        />
      </Box>
      <SearchTable<UserProfile>
        columns={columns}
        filterConfig={getSearchFilters(t)}
        endpoint={DEBTOR_SEARCH}
      />
    </>
  );
}

function getSearchFilters(t: Function) {
  return {
    email: "string",
    mobile: "string",
    externalIdentifier: "string",
    firstName: "string",
    lastName: "string",
  } as FilterConfig;
}
